import { Theme } from "@emotion/react";

type StaticColors = Omit<
  Theme["colors"],
  "primaryColor" | "secondaryColor" | "bgColor"
>;

const staticColors: StaticColors = {
  delete: "#dc3545",
  save: "#99cb56",
  alert: "#ffc241",
  error: "#fdecea",
  kpi: {
    ok: "#417505",
    important: "#E1A10C",
    critical: "#E65C5C",
  },
};

const staticTheme = {
  colors: staticColors,
};

export default staticTheme;
